import Vue from 'vue'
import Router from 'vue-router'
import {changeLang} from "./i18n";

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/start',
  },
  {
    path: '/start',
    component: () => import('@/components/StartPage.vue')
  },

  {
    path: '/login',
    component: () => import('@/components/LoginPage.vue')
  },
  {
    path: '/edit-address',
    component: () => import('@/components/EditAddressPage.vue')
  },
  {
    path: '/sync-services',
    component: () => import('@/components/ServicesPage.vue')
  },
  {
    path: '/finish',
    component: () => import('@/components/FinishPage.vue')
  },
  {
    path: '/identify-start',
    component: () => import('@/components/IdentifyStartPage.vue')
  },
  {
    path: '/identify-fail',
    component: () => import('@/components/IdentifyFailPage.vue')
  },
  {
    path:'/under18',
    component: () => import('@/components/UnqualifyPage.vue')
  },
  {
    path: '/enquiry',
    component: () => import('@/components/Enquiry.vue')
  },

]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes
})

const router = createRouter()


router.beforeEach(
  async (to, from, next) => {
    // Set locale based on url
    const lang = to.query.lang
    if (lang) { changeLang(lang) }
    next();
  }
)

export default router